import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var SurplusCash =
/*#__PURE__*/
function (_BaseData) {
  _inherits(SurplusCash, _BaseData);

  function SurplusCash() {
    _classCallCheck(this, SurplusCash);

    return _possibleConstructorReturn(this, _getPrototypeOf(SurplusCash).call(this, "SurplusCash"));
  }

  _createClass(SurplusCash, [{
    key: "GetByAFSId",
    value: function () {
      var _GetByAFSId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(afsId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByAFSId/").concat(afsId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByAFSId(_x) {
        return _GetByAFSId.apply(this, arguments);
      }

      return GetByAFSId;
    }()
  }, {
    key: "GetViewModel",
    value: function () {
      var _GetViewModel = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(surplusCashId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/vm/Get/").concat(surplusCashId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetViewModel(_x2) {
        return _GetViewModel.apply(this, arguments);
      }

      return GetViewModel;
    }()
  }, {
    key: "GetSurplusAmount",
    value: function () {
      var _GetSurplusAmount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(afsId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetSurplusAmount/").concat(afsId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetSurplusAmount(_x3) {
        return _GetSurplusAmount.apply(this, arguments);
      }

      return GetSurplusAmount;
    }()
  }, {
    key: "UpdateReviewRow",
    value: function () {
      var _UpdateReviewRow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(afsId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/UpdateReviewRow/").concat(afsId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function UpdateReviewRow(_x4) {
        return _UpdateReviewRow.apply(this, arguments);
      }

      return UpdateReviewRow;
    }()
  }, {
    key: "AvaliableDistribution",
    value: function () {
      var _AvaliableDistribution = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(projectId, year) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/AvaliableDistribution/").concat(projectId, "/").concat(year)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function AvaliableDistribution(_x5, _x6) {
        return _AvaliableDistribution.apply(this, arguments);
      }

      return AvaliableDistribution;
    }()
  }]);

  return SurplusCash;
}(BaseData);

export default new SurplusCash();